import { render, staticRenderFns } from "./vistadecompras.vue?vue&type=template&id=2f7894b6"
import script from "./vistadecompras.vue?vue&type=script&lang=js"
export * from "./vistadecompras.vue?vue&type=script&lang=js"
import style0 from "./vistadecompras.vue?vue&type=style&index=0&id=2f7894b6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports